import React, { Component } from "react";
import "./LandingPage.css";

class LandingPage extends Component {

    render() {
        if (this.props.auth0 !== undefined) {
            this.props.auth0.loginWithRedirect();
        }

        return (
            <div className="container-lp">
                <div className="container-content">
                    <div className="logo-lp">
                        <img src="./logo.png" style={{ maxHeight: "40%" }} alt="Artblast logo" />
                    </div>
                </div>
            </div>
        );

    }
}

export default LandingPage;